/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import Popover from 'apollo-react/components/Popover';
import Tooltip from 'apollo-react/components/Tooltip';
import React, { useMemo, useState } from 'react';

import { useTranslation } from '../custom-hooks/useTranslation';

const truncateString = (string, length) => `${string.substring(0, length).trim()}...`;

const isHtml = (str) => {
  const doc = new DOMParser().parseFromString(str, 'text/html');
  return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
};

const renderText = (text, hasHtml) =>
  hasHtml ? <div dangerouslySetInnerHTML={{ __html: text }}></div> : text;

const PopupText = ({ text, maxLength = 100 }) => {
  const translateString = useTranslation();

  const [anchorEl, setAnchorEl] = useState(null);
  const shouldTruncate = text.length > maxLength;
  const hasHtml = useMemo(() => isHtml(text), [text]);

  return shouldTruncate ? (
    <Tooltip title={translateString('Click to expand')}>
      <div>
        <span onClick={(e) => setAnchorEl(e.currentTarget)}>
          {renderText(truncateString(text, maxLength), hasHtml)}
        </span>
        <Popover
          anchorEl={anchorEl}
          open={!!anchorEl}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          slotProps={{
            paper: {
              style: {
                padding: '20px',
                maxWidth: '600px',
              },
            },
          }}
        >
          {renderText(text, hasHtml)}
        </Popover>
      </div>
    </Tooltip>
  ) : (
    renderText(text, hasHtml)
  );
};

export default PopupText;
